module.exports = __webpack_public_path__ + "img/ui-design.ea047b9a.svg";